export const MIN_DAYS_RANGE = 7;
export const EVENT_LOG_REPORT_MIN_DAYS_RANGE = 1;

export const CSV_MAX_SIZE_MB = 250;
